<template>
  <div class="inner-card" :style="{ background: backgroundColor }">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          電腦技能
          <span class="en-text">Computer skills</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="skill.ComputerSkill"
        />
      </div>
    </div>
    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          培訓紀錄
          <span class="en-text">Training record</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="skill.TrainingRecord"
        />
      </div>
    </div>
    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          證照檢定
          <span class="en-text">License test</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="skill.Certificate"
        />
      </div>
    </div>
    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          論文(題目)
          <span class="en-text">Thesis (title)</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="skill.PaperTheme"
        />
      </div>
    </div>
    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          論文(摘要)
          <span class="en-text">Thesis (Abstract)</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="skill.PaperSummary"
        />
      </div>
    </div>
    <div class="field">
      <div class="field-title">
        <span :style="{ color: fontColor }">
          工作專長
          <span class="en-text">Work expertise</span>
        </span>
      </div>
      <div class="field-value">
        <el-input
          class="w-100"
          type="textarea"
          :rows="6"
          maxlength="10000"
          show-word-limit
          v-model="skill.Specialty"
        />
      </div>
    </div>

    <div class="edit-btn-wrap">
      <!-- 儲存 -->
      <button
        type="button"
        class="put-btn"
        @click="saveSkill"
      >
        {{ $t("BUTTON.RESUME_SAVE") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["source", "nextTab", "matchId"],
  name: "AseIDLSkill",
  
  data() {
    return {
      skill: {},

      backgroundColor: "#f1f1f1",
      fontColor: "#000",
    };
  },

  methods: {
    // 儲存 專業技能
    saveSkill() {
      this.$api.idl
        .putSkill(this.source, {
          ...this.skill,
          UserId: this.source === 'resume' ? this.$cookies.get("candidateId") : null,
          MatchId: this.source === "personnelInformation" ? this.matchId : null
        })
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "專業技能儲存成功",
              type: "success",
              duration: 2000,
            });
            if (this.source === 'resume') {
              this.$store.dispatch("GetResumeCompleteness");
            }
            this.getSkill();
            this.$emit("changeTab", this.nextTab);
          }
        });
    },

    // 取得 專業技能
    getSkill() {
      const candidate = this.source === "resume" ? this.$cookies.get("candidateId") : this.matchId;
      this.updateLoading(true);
      this.$api.idl
        .getSkill(this.source, candidate)
        .then((response) => {
          if (response.status === 200) {
            this.skill = response.data;
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(["updateLoading"]),
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  created() {
    this.getSkill();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
};
</script>

<style lang="scss" scoped>
.field-title {
  .en-text {
    opacity: 0.6;
    font-size: 0.85em;
    margin-left: 5px;
  }
}
.edit-btn-wrap {
  .put-btn {
    margin-top: 20px;
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    color: #fff;
    background: #18c58b;
  }
}

/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
  color: #5b5b5b;
  cursor: default;
}
</style>
